import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M5 16v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M19 16v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "20", height: "8", x: "2", y: "8", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 12h0", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "RadioReceiver";
const RadioReceiver = memo(themed(Icon));
export {
  RadioReceiver
};
//# sourceMappingURL=radio-receiver.js.map
